export const selectConfirmation = (state) => state.confirmation;
